import { createFileRoute } from "@tanstack/react-router"
import InstructorDashboard from "@/routes/-pages/InstructorDashboard"

export const Route = createFileRoute("/instructor/dashboard")({
  component: InstructorDashboard,
})
